import { Navigate } from 'react-router';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MARKET_HOME } from '@sorare/core/src/constants/__generated__/routes';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

export const Market = () => {
  return (
    <Navigate
      to={generateSportPath(ANY_SPORT_MARKET_HOME, { sport: Sport.NBA })}
      replace
    />
  );
};

export default Market;
